import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { FlexContainer } from "BaseComponents/Flex";
import {
  Placeholder,
  ImageWrapper,
} from "Framework/lazy/StyledBgImage";

export const PagePuffWrapper = styled(FlexContainer).attrs(
  ({
    padding,
    smallpadding,
    maxHeight,
    flexdir,
    smallflexdirection,
    autoWidth,
    justifycontent,
    imgFullHeight,
  }) => ({
    padding: padding ? padding : "2rem 4rem",
    smallPadding: smallpadding ? smallpadding : "1rem",
    flexDirection: flexdir ? flexdir : "",
    smallDirection: smallflexdirection ? smallflexdirection : "",
    width: autoWidth ? "auto" : "100%",
    justifyContent: justifycontent ? justifycontent : "",
    imgFullHeight: imgFullHeight,
  })
)`
  & {
    ${ImageWrapper} {
      max-height: ${({ imgFullHeight }) =>
        imgFullHeight ? "800px;" : "303px;"};
    }
    position: relative;
    max-width: ${({ theme }) => theme.grid.outer};
    width: ${(props) => props.width};
    padding: ${(props) => props.smallPadding};
    flex-direction: ${(props) => props.smallDirection};
    margin: ${({ margin }) => (margin ? margin : "")};
    justify-content: ${({ justifyContent }) =>
      justifyContent ? justifyContent : ""};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : "stretch")};
    column-gap: 45px;
    ${media.greaterThan(breakpoints.ipad)`
		padding: ${(props) => props.padding};
		`}
    ${media.greaterThan(breakpoints.mobile)`
      flex-direction: ${(props) => props.flexDirection};
	`}
	${media.lessThan(breakpoints.mobile)`
      margin: 0;
      row-gap: ${(props) => props.rowGap};
    `}
  }
`;
